module.exports = __webpack_public_path__ + "static/media/img-home.7ff6efee.svg";